import cb from "Images/profile/cb.png";
import gr from "Images/profile/gr.png";
import gv from "Images/profile/gv.png";
import kb from "Images/profile/kb.png";
import lr from "Images/profile/lr.png";
import lv from "Images/profile/lv.png";
import ng from "Images/profile/ng.png";
import nm from "Images/profile/nm.png";
import og from "Images/profile/og.png";
import om from "Images/profile/om.png";
import td from "Images/profile/td.png";
const images = {
    cb,
    gr,
    gv,
    kb,
    lr,
    lv,
    ng,
    nm,
    og,
    om,
    td,
};
const getAminoAcidProfile = (sku) => images[sku] || td;
export default getAminoAcidProfile;
